import React from "react";

export default function EmptyState({ title = "لا توجد بيانات", description = "ابدأ بإضافة أول عنصر ليظهر هنا." }) {
  return (
    <div className="rounded-[22px] border border-dashed border-slate-300 bg-slate-50 px-4 py-10 text-center sm:px-6 sm:py-12">
      <div className="mx-auto max-w-md">
        <h3 className="text-base font-extrabold text-slate-700 sm:text-lg">{title}</h3>
        <p className="mt-2 text-sm leading-7 text-slate-500">{description}</p>
      </div>
    </div>
  );
}
